import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { SharedModule } from '@/app/shared/shared.module';
import { CropHealthViewModel, NoteViewModel, SatelliteViewModel } from '@/app/proxy/proxies';
import { PlantationService } from '@/app/core/services/plantation.service';
import { CropHealthService } from '../../../../services/crop-health.service';
import { CropHealthMapType } from '../crop-health-map-footer/crop-health-map-footer.component';

@Component({
  selector: 'app-crop-health-map-header',
  imports: [SharedModule],
  templateUrl: './crop-health-map-header.component.html',
  styleUrl: './crop-health-map-header.component.less',
})
export class CropHealthMapHeaderComponent implements OnChanges {
  @Input() cropHealthData: CropHealthViewModel;
  @Input() selectedMapType: CropHealthMapType;
  @Input() loading = false;
  @Input() fullScreenMode = false;
  @Input() notes: NoteViewModel[] = [];
  @Input() selectedDay: SatelliteViewModel;
  @Output() readonly clickFullScreenEvent = new EventEmitter();
  @Output() readonly notesViewChangedEvent = new EventEmitter<boolean>();

  markers: mapboxgl.Marker[];

  constructor(public plantationService: PlantationService, public cropHealthService: CropHealthService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['selectedDay']) {
      if (this.selectedDay?.isCloudly) {
        this.cropHealthService.setShowNotePins(false);
      }
    }
  }

  activateNote() {
    if (this.loading || this.selectedDay?.isCloudly) {
      return;
    }

    this.cropHealthService.setShowNotePins(!this.cropHealthService.showNotePins);
    this.notesViewChangedEvent.emit(this.cropHealthService.showNotePins);
  }
}
